import { useState } from "react";

import { useWatchedDocumentPageIfAny } from "../context/DocumentPageContext";

export function useEditBoxSyncing(bookmarkNames: string[]): boolean {
    const [openedAtMs] = useState(() => Date.now());
    const page = useWatchedDocumentPageIfAny(bookmarkNames);
    return page !== null && bookmarkNames.length > 0 && page.readStartedAtMs < openedAtMs;
}
